import {
  IAddOrEditSahraUser,
  ISahraTableReports,
  ISahraTableSearchParams,
} from "../../Interfaces/SahraTableInterfaces";
import { Report } from "../../Interfaces/TableInterfaces";
import { Packet } from "../../Interfaces/commonDtos";
import { DropdownItem } from "../../Interfaces/dropdownInterfaces";
import { AxiosRequestConfig } from "axios";
import {
  getRequest,
  getTable,
  patchRequest,
  postDownloadExcel,
  postRequest,
} from "../requestTemplates";
import { removeCanTradeManagementColumn } from "../../Utils/sahraUserManagement";

export const getSahraUsersTable = async (
  searchParam: ISahraTableSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig,
): Promise<Report<ISahraTableReports>> => {
  const report = await getTable<
    ISahraTableSearchParams,
    ISahraTableReports
  >(
    "/v1/sahra_user/table",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions,
  );

  return removeCanTradeManagementColumn(report);
};

export const getSahraUserInfo = (id: number): Promise<IAddOrEditSahraUser> =>
  getRequest(`/v1/sahra_user/get?userId=${id}`);

export const getAvailableSahraUserGroups = (): Promise<DropdownItem[]> =>
  getRequest("/v1/sahra_user/groups");

export const addSahraUser = (
  formValues: IAddOrEditSahraUser
): Promise<Packet<boolean>> => postRequest("/v1/sahra_user/add", formValues);

export const editSahraUser = (
  formValues: IAddOrEditSahraUser
): Promise<Packet<boolean>> => patchRequest("/v1/sahra_user/edit", formValues);

export const enableSahraUser = async (
  userid: number
): Promise<Packet<boolean>> => postRequest("/v1/sahra_user/enable", { userid });

export const disableSahraUser = async (
  userid: number
): Promise<Packet<boolean>> =>
  postRequest("/v1/sahra_user/disable", { userid });
export const enableSahraUserTrade = async (
  userid: number
): Promise<Packet<boolean>> =>
  postRequest("/v1/sahra_user/enabletrade", { userid });

export const disableSahraUserTrade = async (
  userid: number
): Promise<Packet<boolean>> =>
  postRequest("/v1/sahra_user/disabletrade", { userid });

export const getSahraUsersExcel = (
  searchParam: ISahraTableSearchParams
) => {
  const rand = Math.random();
  return postDownloadExcel(`/v1/sahra_user/excel?${rand}`, searchParam);
};
